import React, { useState } from 'react';

import { Navbar, Nav } from 'react-bootstrap';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import './About.css';

import { ImArrowDown } from 'react-icons/im';
import {
   FaGithub,
   FaLinkedin,
   FaBars,
} from 'react-icons/fa';
import { FaXTwitter } from "react-icons/fa6";

import './Home.css';
import useLocalStorage from 'use-local-storage';
import { CgSun } from 'react-icons/cg';
import { HiMoon } from 'react-icons/hi';
import Helmet from 'react-helmet';
// import Projects from './Projects/Project';
// import MyProjects from './Projects2/MyProjects';
import Ytvideos from './Ytvideos';
import ProjectContent from './ProjectContent';
import WorkHistory from './WorkHistory';
import BlogSection from './Blog/BlogSection';

function About() {
   let x = ' ✋';

   const [isMobile, setIsMobile] = useState(false);
   const showSidebar = () => setIsMobile(!isMobile);

   const [isActive, setIsActive] = useState(false);
   const disAble = () => setIsActive(!isActive);

   const [theme, setTheme] = useLocalStorage('theme' ? 'dark' : 'light');

   const switchTheme = () => {
      const newTheme = theme === 'light' ? 'dark' : 'light';
      setTheme(newTheme);
   };

   const Styles = styled.div`
      .navbar {
         justify-content: flex-end;
         position: fixed;
         width: 100%;
         z-index: 1;
      }
      a {
         padding: 5px;
         display: flex;
         justify-content: flex-end;
         color: var(--text-primary);
         text-decoration: none;
      }

      .navbar-nav,
      .nav-link {
         height: 60px;
         padding: 10px;
         display: flex;
         justify-content: flex-end;
         color: var(--text-primary);
         text-decoration: none;
         border-bottom: 1px solid #eaecef;
         background-color: var(--background);
      }

      .nav-btn:hover {
         border-bottom: 2px solid #1768ac;
         padding-bottom: 0px;
         width: 60px;
      }
   `;
   return (
      <div data-theme={theme}>
         <Helmet>
            <title>Prosper Onah | Web and Blockchain Developer</title>
            <meta
               name="description"
               content="giving you the the best is our watchword"
            />
            <meta
               name="viewport"
               content="width=device-width, initial-scale=1"
            />
            <meta
               name="keywords"
               content="Prosperity Onah,
          Web Developer,
           Blockchain Developer,
           Software Engineer, 
          Persionate About Ethereum"
            />
         </Helmet>
         <Styles>
            <Navbar>
               <Nav>
                  <div className="menu-bar">
                     <Link to="/" className="nav-btn">
                        Home
                     </Link>
                     <ul>
                        <li>
                           <a className="details">
                              Details
                              <ImArrowDown />
                           </a>
                           <div className="dropdown-menu">
                              <ul>
                                 <li>
                                    <a href="#about">About</a>
                                 </li>
                                 <li>
                                    <a href="#education">Education</a>
                                 </li>
                                 <li>
                                    <a href="#expirience">Experience</a>
                                 </li>
                                 <li>
                                    <a href="#skills">Skills</a>
                                 </li>
                                 <li>
                                    <a href="#blog">Blog</a>
                                 </li>
                                 <li>
                                    <a href="#openSource"> Source</a>
                                 </li>
                                 <li>
                                    <a href="#research">Research</a>
                                 </li>
                                 <li>
                                    <a href="#interest">interest</a>
                                 </li>
                                 <li>
                                    <a href="#project">Project</a>
                                 </li>
                                 <li>
                                    <a href="#contact">Contact</a>
                                 </li>
                              </ul>
                           </div>
                        </li>
                     </ul>
                  </div>
                  <div className="theme-toggle">
                     <i onClick={switchTheme}>
                        {theme === 'dark' ? (
                           <HiMoon size={25} aria-label="my himoon" />
                        ) : (
                           <CgSun size={25} aria-label="my cgsun" />
                        )}
                     </i>
                  </div>
               </Nav>
               <div className="mobileMenu">
                  <FaBars onClick={showSidebar} aria-label="my fabars" />
               </div>
            </Navbar>
         </Styles>

         <div className="container-1">
            <div className="leftside" onClick={showSidebar}>
               <ul className={isMobile ? 'active' : 'sidebar'}>
                  <li className="home">
                     <Link to="/">Home</Link>
                  </li>
                  <li>
                     <a href="#about">About</a>
                  </li>
                  <li>
                     <a href="#education">Education</a>
                  </li>
                  <li>
                     <a href="#expirience">Experience</a>
                  </li>
                  <li>
                     <a href="#skills">Skills</a>
                  </li>
                  <li>
                     <a href="#blog">Blog</a>
                  </li>
                  <li>
                     <a href="#openSource"> Source</a>
                  </li>
                  <li>
                     <a href="#research">Research</a>
                  </li>
                  <li>
                     <a href="#interest">interest</a>
                  </li>
                  <li>
                     <a href="#project">Project</a>
                  </li>
                  <li>
                     <a href="#contact">Contact</a>
                  </li>
               </ul>
            </div>
            <div className="rightside">
               <header className="Header">
                  <div>
                     <h2>Prosper Onah</h2>
                     <p>
                        Blockchain Security Researcher/Smart Contract Engineer
                     </p>
                  </div>
               </header>
               <section className="about" id="about">
                  <h2 className="title">Objective</h2>
                  <hr className="hr" />
                  <p className="aboutme">
                     I am an <strong>award-winning blockchain engineer</strong>, researcher, and smart contract security specialist, with a proven commitment to building secure, scalable decentralized systems. As a <strong>UK Global Talent awardee</strong> in blockchain and an active contributor to public auditing platforms such as <a href="https://audits.sherlock.xyz/watson/prosper" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>Sherlock</a>, <a href="https://code4rena.com/@Prosperity" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>Code4rena</a> and <a href="https://profiles.cyfrin.io/u/otor" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>CodeHawks</a>, I bring a <strong>security-first mindset</strong> and a strong track record of protecting <strong>Millions (TVL)</strong> across DeFi protocols. My core expertise spans <strong>Solidity, YUL/Assembly, Golang, Python, and TypeScript</strong>, with deep practical experience designing, developing, and securing lending protocols, perpetual DEXs, and cross-chain infrastructure. I am equally adept in DAML, and have deployed production-grade infrastructure across EVM-compatible chains and Solana.
                     <br /><br />
                     I have strong interpersonal skills and have worked with large multi-cultural teams and startups, with a core belief in integrity, excellence, and ownership. I am comfortable using AI for code review, best practices, fuzzing assistance, and vulnerability scanning.
                  </p>

                  <h2 className="title">Technical Expertise</h2>
                  <hr className="hr" />
                  <div className="technical-expertise">
                     <table className="expertise-table">
                        <thead>
                           <tr>
                              <th className="category-header">Category</th>
                              <th className="details-header">Details</th>
                           </tr>
                        </thead>
                        <tbody>
                           <tr>
                              <td className="category" data-label="Category"><strong>Platforms</strong></td>
                              <td className="details" data-label="Details">EVM, Layer 2 solutions, Solana, DeFi protocols, cross-chain payment systems</td>
                           </tr>
                           <tr>
                              <td className="category" data-label="Category"><strong>Languages</strong></td>
                              <td className="details" data-label="Details">Solidity, Golang, Postgres, JavaScript, TypeScript, YUL/Assembly, DAML</td>
                           </tr>
                           <tr>
                              <td className="category" data-label="Category"><strong>Frameworks</strong></td>
                              <td className="details" data-label="Details">OpenZeppelin, Hardhat, Foundry, Account Abstraction, Docker, Redis, Gin. PNL Launchpad</td>
                           </tr>
                           <tr>
                              <td className="category" data-label="Category"><strong>Architecture</strong></td>
                              <td className="details" data-label="Details">Smart contract modularity, scalable liquidity aggregation, decentralized cross-chain payments</td>
                           </tr>
                        </tbody>
                     </table>
                  </div>
               </section>

               <WorkHistory />
               {/* <section className="about" id="ytVideos">
                  <Ytvideos />
               </section> */}

               <section className="about" id="myProjects">
                  <ProjectContent />
               </section>

               <BlogSection />

               {/* OPEN SOURCE */}
               <section className="about" id="openSource">
                  <h2 className="title">Open-source / Achievement</h2>
                  <hr className="hr" />
                  <p className="intro-text">
                     My enthusiasm for the Ethereum community has led me to contribute to the following open-source projects.
                  </p>
                  
                  <div className="contributions-grid">
                     {/* Paycrest */}
                     <div className="contribution-card">
                        <div className="card-header">
                           <h3>Paycrest Aggregator</h3>
                           <span className="tag">Development</span>
                        </div>
                        <p className="description">
                           Contributed to the development of Paycrest Aggregator and the integration of the Golang with account abstraction.
                        </p>
                        <a
                           href="https://github.com/paycrest/aggregator"
                           target="_blank"
                           rel="noreferrer"
                           className="card-link"
                        >
                           View Project →
                        </a>
                     </div>

                     {/* EIP-5008 */}
                     <div className="contribution-card">
                        <div className="card-header">
                           <h3>Ethereum Foundation</h3>
                           <span className="tag">EIP</span>
                        </div>
                        <p className="description">
                           Participated in the discussion, development, and review of EIP-5008.
                        </p>
                        <a
                           href="https://github.com/ethereum/EIPs/pull/5008"
                           target="_blank"
                           rel="noreferrer"
                           className="card-link"
                        >
                           View Contribution →
                        </a>
                     </div>

                     {/* Lukso */}
                     <div className="contribution-card">
                        <div className="card-header">
                           <h3>Lukso Network</h3>
                           <span className="tag">Bug Fix</span>
                        </div>
                        <p className="description">
                           Created an issue and a bug fix PR on the update of Openzeppelin to enable ECDSA signature malleability in Lukso network.
                        </p>
                        <a
                           href="https://github.com/lukso-network/lsp-smart-contracts/pull/183"
                           target="_blank"
                           rel="noreferrer"
                           className="card-link"
                        >
                           View Pull Request →
                        </a>
                     </div>

                     {/* Open-source library */}
                     <div className="contribution-card">
                        <div className="card-header">
                           <h3>CEX Database</h3>
                           <span className="tag">Library</span>
                        </div>
                        <p className="description">
                           Created an open-source library for centralized exchange.
                        </p>
                        <a
                           href="https://www.npmjs.com/package/cexdb"
                           target="_blank"
                           rel="noreferrer"
                           className="card-link"
                        >
                           View on NPM →
                        </a>
                     </div>

                     {/* DeFi Data Structure */}
                     <div className="contribution-card">
                        <div className="card-header">
                           <h3>DeFi Data Structure</h3>
                           <span className="tag">Educational</span>
                        </div>
                        <p className="description">
                           Open-source educational repository showcasing data structures and algorithms specifically designed for DeFi applications.
                        </p>
                        <a
                           href="https://github.com/onahprosper/defi-data-structures"
                           target="_blank"
                           rel="noreferrer"
                           className="card-link"
                        >
                           View Repository →
                        </a>
                     </div>

                     {/* Blockchain Data Structure Interview */}
                     <div className="contribution-card">
                        <div className="card-header">
                           <h3>Blockchain Data Structure Interview</h3>
                           <span className="tag">Interview Prep</span>
                        </div>
                        <p className="description">
                           Comprehensive interview preparation guide covering blockchain and data structure concepts with practical examples.
                        </p>
                        <a
                           href="https://github.com/onahprosper/blockchain_data_structure_interview"
                           target="_blank"
                           rel="noreferrer"
                           className="card-link"
                        >
                           View Repository →
                        </a>
                     </div>
                  </div>
               </section>

               <section className="about" id="education">
                  <h2 className="title">Education</h2>
                  <hr className="hr" />
                  <div></div>

                  <div className="education">
                     <div className="divspan">
                        <span>
                           University of Hertfordshire (London)
                        </span>
                        <span>2024 - 2025</span>
                     </div>
                     <p>MSc Cyber Security</p>

                     <div className="divspan">
                        <span>
                           Federal University of Technology Minna (Nigeria)
                        </span>
                        <span>Jan. 2024</span>
                     </div>
                     <p> Bachelor's Degree in Building Technology</p>

                     <div className="divspan">
                        <span>DAMBIS Institute of Technology</span>
                        <span>2014 - 2017</span>
                     </div>
                     <p>Software Engineering</p>


                     <div className="divspan">
                        <span>DApp University </span>
                        <span>2021</span>
                     </div>
                     <p>Blockchain Development</p>
                     <div className="divspan">
                        <span>Udemy </span>
                        <span>2022</span>
                     </div>
                     <p>Advance Solidity: Yul and Assembly</p>
                  </div>
               </section>

               {/* <section className="about" id="research">
                  <h2 className="title">Research</h2>
                  <hr className="hr" />
                  <div></div>

                  <div className="Item">
                     <li>FHE.</li>
                     <li>Permissioned Blockchain</li>
                     <li>MEV</li>
                     <li>Account Abstraction.</li>
                     <li>Sharding.</li>
                     <li>
                        Research on the ETH Proof-of-work and Proof-of-stake
                        algorithm.
                     </li>
                     <li>Research of Starknet Layer II protocol.</li>
                     <li>Defi, and Smart Contracts Hacks.</li>
                     <li>CAIRO SHA 256 Algorithm.</li>
                  </div>
               </section> */}
               <section className="about" id="interest">
                  <h2 className="title">Interest</h2>
                  <hr className="hr" />
                  <div></div>
                  <p>
                     I'm always interested in innovation regarding blockchain, innovation tools.
                  </p>
               </section>
               <section className="about" id="contact">
                  <h2 className="title">Contact</h2>
                  <hr className="hr" />
                  <div></div>
                  <p>
                     open to getting in touch with awesome people and projects.
                  </p>
               </section>
               <div className="Header">
                  <ul className="social">
                     <li>
                        <a
                           href="https://github.com/OnahProsper"
                           target="_blank"
                           aria-label="my github"
                           rel="noreferrer"
                        >
                           <FaGithub />
                        </a>
                     </li>
                     <li>
                        <a
                           href="https://x.com/x07154"
                           target="_blank"
                           aria-label="my X"
                           rel="noreferrer"
                        >
                           <FaXTwitter />
                        </a>
                     </li>
                     <li>
                        <a
                           href="https://www.linkedin.com/in/prosper-o-3050791a6/"
                           target="_blank"
                           aria-label="my linkedin"
                           rel="noreferrer"
                        >
                           <FaLinkedin />
                        </a>
                     </li>
                     {/* <li>
                <a
                  href="https://prosperauthor@gmail.com"
                  target="_blank"
                  aria-label="my telegram"
                  rel="noreferrer"
                >
                  <FiMail />
                </a>
              </li> */}
                  </ul>
                  <hr className="hr" />
                  <p>{x}</p>
               </div>
               <h1 className="edit"></h1>
            </div>
         </div>
      </div>
   );
}

export default About;
